import React, { useContext } from 'react';
import { CRow, CCol, CCard, CCardHeader, CCardBody } from '@coreui/react';
import { connect, DispatchProp } from 'react-redux';
import * as pluralize from 'pluralize';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory } from 'react-router-dom';
import { LoadUploads} from '../actions';
import useInterval from '../../shared/hooks/useInterval.hook';
import BulkUploader from './BulkUploader';
import UploadList from '../components/UploadList';
import { ConfigContext } from '../../shared/contexts/journeyConfig.context';

// We poll the uploads endpoint every two seconds
const POLLING_INTERNAL = 5000;

const JobsUploadPage = ({ dispatch }: DispatchProp) => {
  const labels = useContext(ConfigContext);
  const { enableBulkUploadModule } = useFlags();
  const history = useHistory();

  if (!enableBulkUploadModule) {
    history.push('/dashboard');
    return null;
  }

  const fetchUploads = () => dispatch(new LoadUploads());
  fetchUploads();
  useInterval(() => fetchUploads(), POLLING_INTERNAL);

  return (
    <>
      <CRow>
        <CCol lg="12">
          <CCard className="glympser-container--roundedWithShadow">
            <CCardHeader className="border-0 glympser-roundedTop">
              {pluralize(labels.task)} Bulk Upload
            </CCardHeader>
            <BulkUploader />
          </CCard>
          <CCard className="glympser-container--roundedWithShadow">
            <CCardBody>
              <UploadList />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default connect(null)(JobsUploadPage);
